export default {
  TITLE: `Your schedule was published`,
  SUMMARY: ``,
  PRIMARY_ACTION: `I have seen my shifts`,
  POSITION: `Position`,
  START: `Start`,
  END: `End`
}
